import { Box, Card, CardContent, Typography } from "@mui/material";
import { FC } from "react";
import { figureFormatter } from "../../../utils/figure_formatter";
import { getName } from "../../Clients/models/ColumnShape";
import StatusBtn from "../../../components/UI/StatusBtn";
import { useNavigate } from "react-router-dom";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { Span } from "../../../components/Typography";

interface IDetailsInfo {
  entityDetails: any;
}

const ClientAccountActivation: FC<IDetailsInfo> = ({ entityDetails }) => {
  const navigate = useNavigate();

  return (
    <Card sx={{ borderRadius: 3, overflow: "hidden", maxWidth: 520 }}>
      <CardContent>
        <Typography
          sx={{
            fontSize: 14,
            mb: 1.5,
            fontWeight: "bold",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          gutterBottom
        >
          Account Details
          <Box
            sx={{ display: "inline-block" }}
            onClick={() => {
              navigate(`/clients/client-profile/${entityDetails?.client}`);
            }}
          >
            <StatusBtn
              type={1}
              title={
                <Span display={"inline-flex"} padding={0.5} gap={1}>
                  More <ArrowOutwardIcon fontSize={"small"} color="primary" />
                </Span>
              }
            />
          </Box>
        </Typography>

        <Box>
          <Box>
            <Typography
              sx={{ fontSize: 14, mb: 1.5 }}
              color="text.disabled"
              gutterBottom
            >
              Client name
            </Typography>
            <Typography sx={{ fontSize: 14, mb: 1.5 }}>
              {entityDetails?.client_name}
            </Typography>
          </Box>
          {entityDetails?.account_type && (
            <Box>
              <Typography
                sx={{ fontSize: 14, mb: 1.5 }}
                color="text.disabled"
                gutterBottom
              >
                Account type
              </Typography>
              <Typography sx={{ fontSize: 14, mb: 1.5 }}>
                {entityDetails?.account_type}
              </Typography>
            </Box>
          )}
          <Box>
            <Typography
              sx={{ fontSize: 14, mb: 1.5 }}
              color="text.disabled"
              gutterBottom
            >
              Account Balance
            </Typography>
            <Typography sx={{ fontSize: 14, mb: 1.5 }}>
              {figureFormatter({
                figure: entityDetails?.acc_balance,
                currency: entityDetails?.currency?.currency || "",
              })}
            </Typography>
          </Box>
          {entityDetails?.membership_no && (
            <Box>
              <Typography
                sx={{ fontSize: 14, mb: 1.5 }}
                color="text.disabled"
                gutterBottom
              >
                Membership No
              </Typography>
              <Typography sx={{ fontSize: 14, mb: 1.5 }}>
                {entityDetails?.membership_no}
              </Typography>
            </Box>
          )}
          {entityDetails?.wallet_no && (
            <Box>
              <Typography
                sx={{ fontSize: 14, mb: 1.5 }}
                color="text.disabled"
                gutterBottom
              >
                Wallet No
              </Typography>
              <Typography sx={{ fontSize: 14, mb: 1.5 }}>
                {entityDetails?.wallet_no}
              </Typography>
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ClientAccountActivation;
